import { render, staticRenderFns } from "./pressDeviceInfo.vue?vue&type=template&id=6d488e34"
import script from "./pressDeviceInfo.vue?vue&type=script&lang=js"
export * from "./pressDeviceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports